import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import useDebounce from '@/utils/debounce';
import MembersPermissionAddRow from '@/users/membership/components/MembersPermissionAddRow';
import memberEntities from '@/users/membership/constants';
import {
  addDatasetMembers, fetchDatasetMembers, updateDatasetMembersProperties, updateShareDatasetProperties,
} from '../actions';
import { datasetPermissionGroups } from '../constants';

const DatasetMemberAddRow = ({
  members,
  membersToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addMembers,
  readStatus,
  filter,
  permission,
  allowSecure,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const onFilterChange = useCallback((value) => {
    updateFilter(value);
    debouncedFetch(value);
  }, [updateFilter, debouncedFetch]);

  return (
    <MembersPermissionAddRow
      addMembers={addMembers}
      allowSecure={allowSecure}
      entity="dataset"
      filter={filter}
      members={members}
      onFilterChange={onFilterChange}
      membersToAdd={membersToAdd}
      permission={permission}
      permissionGroups={datasetPermissionGroups}
      readStatus={readStatus}
      updateProperties={updateProperties}
    />
  );
};

export const mapStateToProps = ({
  datasetUsers: {
    sharingDataset,
  },
}) => {
  const {
    unassignedMembers, members, permissionGroup, membersToAdd,
  } = sharingDataset;

  const {
    filter, readErrors, readStatus, results,
  } = unassignedMembers;

  const uuids = members.results.filter(
    (member) => member.entity === memberEntities.USER,
  ).map((member) => member.uuid);

  const codes = members.results.filter(
    (member) => member.entity === memberEntities.USERGROUP,
  ).map((member) => member.code);

  const assignable = results.filter((member) => !uuids.includes(member.uuid) && !codes.includes(member.code));

  return (
    {
      permission: permissionGroup,
      members: membersToAdd.concat(assignable),
      membersToAdd,
      filter,
      readErrors,
      readStatus,
    }
  );
};

const mapDispatchToProps = {
  addMembers: addDatasetMembers,
  fetchData: (filter) => fetchDatasetMembers(true, filter),
  updateFilter: (filter) => updateDatasetMembersProperties(true, { filter }),
  updateProperties: updateShareDatasetProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetMemberAddRow);
